// COPYRIGHT SMARTTRACK

/**
 * Requires
 */

const { BrowserMultiFormatReader } = require('@zxing/library');


/**
 * State
 */

let codeReader = null;
let isScanning = false;


/**
 * Scanner Handlers
 */

exports.initializeScanner = () => {
	if (codeReader === null) {
		codeReader = new BrowserMultiFormatReader();
	}
	return codeReader;
};

exports.startScanning = async (videoElement, onResultCallback, onErrorCallback) => {
	if (isScanning) return;

	try {
		isScanning = true;
		const reader = exports.initializeScanner();

		await reader.decodeFromVideoDevice(null, videoElement, (result, err) => {
			if (result) {
				if (onResultCallback) onResultCallback(result.getText());
			}
			if (err && err.name !== 'NotFoundException') {
				if (onErrorCallback) onErrorCallback(err);
			}
		});
	} catch (err) {
		isScanning = false;
		if (onErrorCallback) onErrorCallback(err);
	}
};

exports.stopScanning = () => {
	if (codeReader) {
		codeReader.reset();
		isScanning = false;
	}
};

exports.isCurrentlyScanning = () => isScanning;


/**
 * Camera Permission Handlers
 */

exports.checkCameraPermission = async () => {
	try {
		const stream = await navigator.mediaDevices.getUserMedia({ video: true });
		stream.getTracks().forEach((track) => track.stop());
		return 'granted';
	} catch (err) {
		return 'denied';
	}
};

exports.requestCameraAccess = async () => {
	try {
		const stream = await navigator.mediaDevices.getUserMedia({
			video: { facingMode: 'environment' },
		});
		stream.getTracks().forEach((track) => track.stop());
		return true;
	} catch (err) {
		return false;
	}
};
